module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/desktop/dashkit-d9bab54d1d0af5bf074b7d9640394eab.jpg";